import { useAiAskBarRefs } from './useAiAskBarRefs'
import { useAiAskBarRefinement } from './useAiAskBarRefinement'
import { useAiAskBarUiState } from './useAiAskBarUiState'

export function useAiAskBarState({ variant, placeholder: placeholderProp, stackedToolbar, buildMode = false }) {
  const isEmailReply = variant === 'emailReply'
  const isComposerVariant = variant === 'compact' || isEmailReply
  const effectiveStackedToolbar = stackedToolbar || isEmailReply

  const ui = useAiAskBarUiState()
  const refs = useAiAskBarRefs(ui.attachments)
  const refinement = useAiAskBarRefinement({
    composerEditorRef: refs.composerEditorRef,
    setComposerPlainText: ui.setComposerPlainText,
  })
  const inputPlaceholder = placeholderProp ?? (refinement.refinementText ? 'What needs to change?' : buildMode ? 'Build' : 'Ask Anything')

  return {
    isEmailReply,
    isComposerVariant,
    effectiveStackedToolbar,
    inputPlaceholder,
    buildMode,
    ...ui,
    ...refs,
    ...refinement,
  }
}
